(function() {
  'use strict';

  /**
   * Initialize product specifications tabs functionality
   */
  function initProductSpecTabs() {
    const tabSets = document.querySelectorAll('.js-product-spec__tabset');
    if (!tabSets.length) return;

    tabSets.forEach(function(tabSet) {
      const tabs = tabSet.querySelectorAll('.js-product-spec__tab-button');
      if (!tabs.length) return;

      const wrapper = tabSet.closest('.product-spec__wrapper');
      if (!wrapper) return;

      const tabPanels = wrapper.querySelectorAll('.js-product-spec__tab-content');
      if (!tabPanels.length) return;

      // Ensure only first tab is visible on load
      tabs.forEach(function(tab, index) {
        const panelId = tab.getAttribute('aria-controls');
        if (!panelId) return;
        
        const panel = document.getElementById(panelId);
        if (!panel) return;
        
        if (index === 0) {
          panel.classList.remove('hidden');
          panel.style.display = '';
        } else {
          panel.classList.add('hidden');
          panel.style.display = 'none';
        }
      });

      // Initialize tab handlers
      tabs.forEach(function(tab, index) {
        // Click handler
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          switchTab(tabs, tab);
        });

        // Keyboard navigation
        tab.addEventListener('keydown', function(e) {
          let targetTab = null;

          switch(e.key) {
            case 'ArrowLeft':
              e.preventDefault();
              targetTab = tabs[index > 0 ? index - 1 : tabs.length - 1];
              break;
            case 'ArrowRight':
              e.preventDefault();
              targetTab = tabs[index < tabs.length - 1 ? index + 1 : 0];
              break;
            case 'Home':
              e.preventDefault();
              targetTab = tabs[0];
              break;
            case 'End':
              e.preventDefault();
              targetTab = tabs[tabs.length - 1];
              break;
          }

          if (targetTab) {
            targetTab.focus();
            switchTab(tabs, targetTab);
          }
        });
      });
    });
  }

  /**
   * Switch to a specific tab
   */
  function switchTab(tabs, activeTab) {
    const panelId = activeTab.getAttribute('aria-controls');
    if (!panelId) return;
    
    const activePanel = document.getElementById(panelId);
    if (!activePanel) return;

    // Update all tabs
    tabs.forEach(function(tab) {
      const isActive = tab === activeTab;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    // Hide all panels
    tabs.forEach(function(tab) {
      const tabPanelId = tab.getAttribute('aria-controls');
      if (!tabPanelId) return;
      
      const panel = document.getElementById(tabPanelId);
      if (!panel) return;
      
      if (panel === activePanel) {
        panel.classList.remove('hidden');
        panel.style.display = '';
        // Check scroll indicator after showing panel
        setTimeout(function() {
          const table = panel.querySelector('.js-product-spec__table');
          if (table) {
            checkScrollIndicator(table);
          }
        }, 100);
      } else {
        panel.classList.add('hidden');
        panel.style.display = 'none';
      }
    });
  }

  /**
   * Format prices using Shopify.formatMoney
   */
  function formatPrices() {
    // Check if Shopify.formatMoney is available
    if (typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') {
      console.warn('Product Spec: Shopify.formatMoney is not available');
      return;
    }

    // Check if moneyFormat is available
    if (typeof window.moneyFormat === 'undefined') {
      console.warn('Product Spec: window.moneyFormat is not defined');
      return;
    }

    const priceElements = document.querySelectorAll('.js-product-spec__price[data-price]');
    priceElements.forEach(function(priceEl) {
      const priceInCents = parseInt(priceEl.getAttribute('data-price'), 10);
      if (isNaN(priceInCents)) return;

      const formattedPrice = Shopify.formatMoney(priceInCents, window.moneyFormat);
      priceEl.textContent = formattedPrice;
    });
  }

  /**
   * Check if table has horizontal scroll and show/hide indicator
   * Update indicator width and position based on scroll
   */
  function checkScrollIndicator(table) {
    if (!table) return;

    const wrapper = table.closest('.js-product-spec__table-wrapper');
    if (!wrapper) return;

    const indicator = wrapper.querySelector('.js-product-spec__scroll-indicator');
    if (!indicator) return;

    const indicatorBar = indicator.querySelector('.js-product-spec__scroll-indicator-bar');
    if (!indicatorBar) return;

    // Check if table has horizontal scroll
    const hasScroll = table.scrollWidth > table.clientWidth;

    if (hasScroll) {
      indicator.classList.add('is-visible');
      
      // Calculate indicator bar width based on remaining scrollable content
      const scrollWidth = table.scrollWidth;
      const clientWidth = table.clientWidth;
      const scrollLeft = table.scrollLeft;
      const maxScrollLeft = scrollWidth - clientWidth;
      
      if (maxScrollLeft > 0) {
        // Remaining scrollable content
        const remainingScroll = maxScrollLeft - scrollLeft;
        
        // Width of indicator = remaining scroll / max scroll * 100%
        // This makes indicator wider at the start and narrower as we scroll right
        const barWidthPercent = (remainingScroll / maxScrollLeft) * 100;
        
        // Position indicator from the right
        const barLeftPercent = 100 - barWidthPercent;
        
        indicatorBar.style.width = barWidthPercent + '%';
        indicatorBar.style.left = barLeftPercent + '%';
      } else {
        indicatorBar.style.width = '100%';
        indicatorBar.style.left = '0%';
      }
    } else {
      indicator.classList.remove('is-visible');
    }
  }

  /**
   * Initialize scroll indicators for all tables
   */
  function initScrollIndicators() {
    const tables = document.querySelectorAll('.js-product-spec__table');
    if (!tables.length) return;

    tables.forEach(function(table) {
      // Check on load
      checkScrollIndicator(table);

      // Update on scroll
      table.addEventListener('scroll', function() {
        checkScrollIndicator(table);
      }, { passive: true });

      // Check on resize
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          checkScrollIndicator(table);
        }, 250);
      });

      // Check on tab switch
      const tabContent = table.closest('.js-product-spec__tab-content');
      if (tabContent) {
        const observer = new MutationObserver(function() {
          setTimeout(function() {
            checkScrollIndicator(table);
          }, 100);
        });

        observer.observe(tabContent, {
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      }
    });
  }

  /**
   * Initialize all product spec functionality
   */
  function initProductSpec() {
    initProductSpecTabs();
    formatPrices();
    initScrollIndicators();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSpec);
  } else {
    initProductSpec();
  }
})();
